import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { featureFlagActions } from '../../store/featureFlags.slice';

import type { AppDispatch, RootState } from '../../store';

function useFeatureFlagsAdmin() {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const { flags, loading } = useSelector((state: RootState) => state.featureFlags);

  function loadFlags() {
    dispatch(featureFlagActions.getFeatureFlags({ getAccessTokenSilently }));
  }

  function toggleFlag(key: string, enabled: boolean, password: string) {
    dispatch(
      featureFlagActions.setFeatureFlag({
        key,
        enabled,
        getAccessTokenSilently,
        // The getter keeps the password value out of Redux action metadata.
        getAdminActionPassword: () => password,
      }),
    );
  }

  function addFlag(key: string, password: string) {
    dispatch(
      featureFlagActions.setFeatureFlag({
        key,
        enabled: false,
        getAccessTokenSilently,
        // The getter keeps the password value out of Redux action metadata.
        getAdminActionPassword: () => password,
      }),
    );
  }

  return { flags, loading, loadFlags, toggleFlag, addFlag };
}

export default useFeatureFlagsAdmin;
